// Version : 0.0.3
// Author : VIGNESH
// LastEdit: VIGNESH
// MODFIED DATE : 07-12-2025
// LAST MOFIFIED: ADDED COMMENTS AND REMOVED UNWANTED REDUX

import GoldloanInterestReminderReportTypes from './gold-loan-interest-reminder-report.types';
import { docodeHexResponse } from '../../_common/common.utils';
const INITIAL_STATE = {
	fetchRequestReportDetailsResponse: null,
	fetchRequestReportDetailsArr: [],
};

const goldloanInterestReminderReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************* GOLD LOAN INTEREST REMINDER REPORT START *********** */
		case GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_SUCCESS:
			return {
				...state,
				fetchRequestReportDetailsResponse: action.payload,
				fetchRequestReportDetailsArr: docodeHexResponse(
					action.payload,
					'FetchGoldLoanInterestReminderKey',
				),
			};

		case GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_FAILURE:
			return { ...state, fetchRequestReportDetailsResponse: action.payload };

		case GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchRequestReportDetailsResponse: null };
		/************* GOLD LOAN INTEREST REMINDER REPORT END *********** */
		default:
			return state;
	}
};

export default goldloanInterestReminderReportReducer;
